
<div class="row" style="zoom: 100%;">
  <div class="col-12">
    <div class="card">
      <div class="card-header bg-gradient-gray-dark text-orange">
        <i class="fas fa-chart-pie"></i><strong>&nbsp;Performance KPIs</strong>
      </div>

      <div class="row " style="margin:7px;  min-height:280px;"  *ngIf="showReachabilityDetails">
        <app-cc-line-delay-drop-graph *ngIf="fullLineInfo!=null&&!isPair" [isMonitored]="fullLineInfo?.isMonitored" [ipAddress]="fullLineInfo?.ipAddress" [lineId]="fullLineInfo?.id" [style]="{'width':'100%'}"></app-cc-line-delay-drop-graph>
        <app-cc-line-delay-drop-graph *ngIf="parentFullLineInfo!=null&&isPair" [isMonitored]="parentFullLineInfo?.isMonitored" [ipAddress]="parentFullLineInfo?.ipAddress" [lineId]="parentFullLineInfo?.id" [style]="{'width':'100%'}"></app-cc-line-delay-drop-graph>
      </div>

          <div class="row " style="margin:7px;  min-height:280px;">
            <div class="col-md-12 col-sm-12">
              <app-line-traffic-digest-graph *ngIf="fullLineInfo!=null&&!isPair" [isMonitored]="fullLineInfo?.isMonitored" [lineId]="fullLineInfo?.id" [style]="{'width':'100%'}"></app-line-traffic-digest-graph>
              <app-line-traffic-digest-graph *ngIf="fullLineInfo!=null&&isPair" [isMonitored]="parentFullLineInfo?.isMonitored" [lineId]="parentFullLineInfo?.id" [style]="{'width':'100%'}"></app-line-traffic-digest-graph>
            </div>

            <!-- Don't show Delay/drop graphs' -->
            <!--<div class="col-md-6 col-sm-12" style="min-height:280px" *ngIf="showReachabilityDetails">
              *ngIf="fullLineInfo?.basicInfo!=null"
              <app-cc-line-delay-drop-graph *ngIf="fullLineInfo!=null&&!isPair" [isMonitored]="fullLineInfo?.isMonitored" [ipAddress]="fullLineInfo?.ipAddress" [lineId]="fullLineInfo?.id" [style]="{'width':'100%'}"></app-cc-line-delay-drop-graph>
              <app-cc-line-delay-drop-graph *ngIf="fullLineInfo!=null&&isPair" [isMonitored]="parentFullLineInfo?.isMonitored" [ipAddress]="parentFullLineInfo?.ipAddress" [lineId]="parentFullLineInfo?.id" [style]="{'width':'100%'}"></app-cc-line-delay-drop-graph>
            </div>-->

            <!--hide status logs section-->
            <!--<div class="col-md-6 col-sm-12" style="min-height: 280px">-->
              <!--*ngIf="fullLineInfo?.basicInfo!=null"-->
              <!--<app-avilability-graph *ngIf="fullLineInfo!=null" [isMonitored]="fullLineInfo?.isMonitored" [lineId]="fullLineInfo?.id" [deviceIP]="fullLineInfo?.ipAddress" [pairNum]="fullLineInfo.pairNum" [style]="{'width':'100%'}"></app-avilability-graph>
            </div>-->
          </div>
        </div>
    </div>
</div>

<div class="row" style="zoom:100%;">
  <div class="col-6">
    <div class="card">
      <div class="card-header bg-gradient-gray-dark text-orange">
        <i class="fas fa-chart-line"></i><strong> Line Statistics </strong>

      </div>
      <div class="row m-2 centered-content">
        <app-cc-line-statistics *ngIf="fullLineInfo!=null" [line]="fullLineInfo" [isPair]="isPair" [parentLine]="parentFullLineInfo" [style]="{'width':'100%'}"></app-cc-line-statistics>
      </div>
    </div>
  </div>
  <div class="col-6">
    <div class="card">
      <div class="card-header bg-gradient-gray-dark text-orange">
        <i class="fas fa-wrench"></i><strong>&nbsp;Tickets History</strong>&nbsp;

      </div>
      <div class="row m-2 centered-content">
        <!--*ngIf="fullLineInfo?.basicInfo!=null"-->
        <app-cc-ticket *ngIf="fullLineInfo!=null" [lineQuote]="fullLineInfo?.quoteID" [lineId]="fullLineInfo?.id" [style]="{'width':'100%'}"></app-cc-ticket>

      </div>
      <!--<div class="card-footer bg-gray-light" style="text-align:center">
        <a href="#/line-tickets-full/{{fullLineInfo?.quoteID}}/{{fullLineInfo?.id}}">
          More info <i class="fas fa-arrow-circle-right"></i>
        </a>
      </div>-->

    </div>
  </div>
</div>




<div class="row" style="zoom:100%;">
  <div class="col-12">
    <div class="card">
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <!--<app-map [outerMap]="true"></app-map>-->
          <!--*ngIf="fullLineInfo?.basicInfo?.name !=null || fullLineInfo?.basicInfo?.name !=undefined"-->
          <app-map *ngIf="fullLineInfo?.name !=null || fullLineInfo?.name !=undefined"
                   [outerMap]="false" [lineId]="fullLineInfo.id" [lineName]="fullLineInfo?.name" [popName]="fullLineInfo?.popName"></app-map>
        </div>
      </div>
    </div>
  </div>
</div>
